/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ReactNode } from "react";

type Props<T> = {
  condition: T;
  children: ((condition: T) => ReactNode) | ReactNode;
  else?: ((condition: T) => ReactNode) | ReactNode;
};

export const If = <T,>({
  condition,
  children,
  else: elseContent,
}: Props<T>) => {
  if (condition) {
    return (
      <>{typeof children === "function" ? children(condition) : children}</>
    );
  }

  if (!elseContent) {
    return null;
  }

  return (
    <>
      {typeof elseContent === "function" ? elseContent(condition) : elseContent}
    </>
  );
};
